import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getAgencySettings } from '../service';

function useAgencySettings() {
    const query = useQuery({
        queryKey: ['agencyServiceSettings'],
        queryFn: () => getAgencySettings(),
    });

    return {
        agencySettings: query.data,
        isLoading: query.isLoading,
    };
}

function usePrefetchAgencySettings() {
    const queryClient = useQueryClient();

    useEffect(() => {
        void queryClient.prefetchQuery({
            queryKey: ['agencyServiceSettings'],
            queryFn: () => getAgencySettings(),
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export { useAgencySettings, usePrefetchAgencySettings };
